import {NotificationInteraction, type NotificationInteractionData} from "@/types/site_admin/notificationInteraction";

export class SiteNotification {
    public id: number | null;
    public client_name: string;
    public client_message: string;
    public client_email_text: string;
    public client_email_subject: string;
    public client_enabled: boolean;
    public client_force_show: number;
    public client_from: Date | null;
    public client_until: Date | null;
    public notificationInteractions: NotificationInteraction[];

    constructor(data: SiteNotificationData | void) {
        if (data === undefined) {
            this.id = null;
            this.client_name = "";
            this.client_message = "";
            this.client_email_text = "";
            this.client_email_subject = "";
            this.client_enabled = false;
            this.client_force_show = 0;
            this.client_from = null;
            this.client_until = null;
            this.notificationInteractions = [];
        } else {
            this.id = data.id;
            this.client_name = data.client_name;
            this.client_message = data.client_message;
            this.client_email_text = data.client_email_text;
            this.client_email_subject = data.client_email_subject;
            this.client_enabled = data.client_enabled;
            this.client_force_show = data.client_force_show;

            this.client_from = null;
            if (data.client_from !== null) {
                this.client_from = new Date(data.client_from);
            }

            this.client_until = null;
            if (data.client_until !== null) {
                this.client_until = new Date(data.client_until);
            }

            this.notificationInteractions = [];
            if (data.notificationInteractions !== undefined) {
                data.notificationInteractions.forEach(notificationInteraction => this.notificationInteractions.push((new NotificationInteraction(notificationInteraction))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data = {
            id: this.id,
            client_name: this.client_name,
            client_message: this.client_message,
            client_email_text: this.client_email_text,
            client_email_subject: this.client_email_subject,
            client_enabled: this.client_enabled,
            client_force_show: this.client_force_show,
            client_from: this.client_from,
            client_until: this.client_until,
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('notificationInteractions')
            )
        ) {
            serialized_data.notificationInteractions = [];
            this.notificationInteractions.forEach(el => {
                serialized_data.notificationInteractions.push(el.serializeData())
            })
        }

        return serialized_data;
    }

    // public serializeData(): SiteNotificationData {
    //     return {
    //         id: this.id,
    //         client_name: this.client_name,
    //         client_message: this.client_message,
    //         client_email_text: this.client_email_text,
    //         client_email_subject: this.client_email_subject,
    //         client_enabled: this.client_enabled,
    //         client_force_show: this.client_force_show,
    //         client_from: this.client_from,
    //         client_until: this.client_until,
    //     };
    // }

    public resetToDefaults(): void {
        this.id = null;
        this.client_name = "";
        this.client_message = "";
        this.client_email_text = "";
        this.client_email_subject = "";
        this.client_enabled = false;
        this.client_force_show = 0;
        this.client_from = null;
        this.client_until = null;
    }
}

export type SiteNotificationData = {
    id: number | null;
    client_name: string;
    client_message: string;
    client_email_text: string;
    client_email_subject: string;
    client_enabled: boolean;
    client_force_show: number;
    client_from: Date | null;
    client_until: Date | null;
    notificationInteractions: NotificationInteractionData[];
}
